// services/firestore/admins.ts — Read path for the admin allowlist.

import { collection, getDocs } from 'firebase/firestore';
import { db } from '@/services/firebase';
import type { AdminAllowlistEntry } from '@/types/domain';

export async function listAdmins(): Promise<AdminAllowlistEntry[]> {
  const snap = await getDocs(collection(db, 'admins'));
  return snap.docs.map((d) => {
    const data = d.data() as Record<string, unknown>;
    return {
      uid: d.id,
      role:
        data.role === 'owner'
          ? 'owner'
          : data.role === 'admin'
          ? 'admin'
          : 'member',
      email: (data.email as string | null) ?? null,
      note: (data.note as string | null) ?? null,
      createdAt:
        (data.createdAt as AdminAllowlistEntry['createdAt']) ?? null,
    };
  });
}
